var map = {
	"./AdultCAP2025.json": 506,
	"./AdultCAP2026.json": 723,
	"./CHRB2024.json": 66,
	"./LIDA2024.json": 437,
	"./LIDA2025.json": 706,
	"./SCHRB2024.json": 353,
	"./SCHRB2026.json": 343,
	"./SteelSpoon2025.json": 326,
	"./StudentsCAP2025.json": 48,
	"./StudentsCAP2026.json": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 0;